import PropTypes from 'prop-types';
import { useMemo } from 'react';

const generateColor = (fullName, saturation, lightness) => {
  let hash = 0;
  for (let i = 0; i < fullName?.length; i++) {
    hash = fullName?.charCodeAt(i) + ((hash << 5) - hash);
  }
  let h = hash % 360;
  return 'hsl(' + h + ', ' + saturation + '%, ' + lightness + '%)';
};

const InitialsIcon = ({ className, initials, fullName }) => {
  const backgroundColor = useMemo(() => generateColor(fullName, 30, 50), [fullName]);

  if (!initials) {
    return null;
  }

  return (
    <div className={className} style={{ backgroundColor }} data-testid="initials-icon">
      <span>{initials}</span>
    </div>
  );
};

InitialsIcon.propTypes = {
  className: PropTypes.string,
  initials: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
};

export default InitialsIcon;
